import React from 'react'
import SMSVerify from '../../../SMSVerify'

export default function PageDemo() {
  return (<>
    <SMSVerify /></>
  )
}
